export const PRIVAT_INITIAL_ROUTE = `/live-feeds`
